module.exports = __webpack_public_path__ + "img/icon_category_04.bf08c1af.svg";